import { Outlet } from "react-router-dom"

const WorkPage = () => {
    return (
        <Outlet />
    );
};

export default WorkPage;
